import { EventTracking, EventType } from '@app/tracking';
export default class GoogleAnalyticsGTag {
    constructor(scriptPath, propertyId, anonymizeIp) {
        this.propertyId = propertyId;
        // Setup script tag
        const scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = scriptPath + '?id=' + propertyId;
        document.body.appendChild(scriptTag);
        // Setup data layer
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        // Initialize
        gtag('js', new Date());
        gtag('config', propertyId, { 'anonymize_ip': anonymizeIp });
        if (window.laravelDebug) {
            console.log(`✅ Google GTag Tracking initialized for "${propertyId}"`);
        }
        this.registerListeners();
    }
    registerListeners() {
        // Page view
        EventTracking.listen(EventType.PageView, ({ title, path, isFirstPageLoad = false }) => {
            if (!isFirstPageLoad) {
                gtag('config', this.propertyId, {
                    'page_title': title,
                    'page_path': path
                });
            }
        });
        // Form submit
        EventTracking.listen(EventType.FormSubmit, ({ form }) => {
            this.sendEvent('ContactForm', 'submit', form);
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, ({ form }) => {
            this.sendEvent('ContactForm', 'success', form);
        });
        // Form error
        EventTracking.listen(EventType.FormError, ({ form, error }) => {
            this.sendEvent('ContactForm', 'error', form, error);
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, ({ searchQuery }) => {
            this.sendEvent('Location', 'Search', searchQuery);
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, event => {
            this.sendEvent('Shop', 'AddToCart', event.sku, event.price);
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceRemoveItem, event => {
            this.sendEvent('Shop', 'RemoveFromCart', event.sku, event.price);
        });
        // Shop Go to Checkout
        EventTracking.listen(EventType.EcommerceCheckout, event => {
            this.sendEvent('Shop', 'Checkout', event.id, event.total);
        });
        // Web Vitals
        EventTracking.listen(EventType.WebVitalsMetric, ({ id, name, delta }) => {
            gtag('event', name, {
                event_category: 'Web Vitals',
                // Google Analytics metrics must be integers, so the value is rounded.
                // For CLS the value is first multiplied by 1000 for greater precision
                // (note: increase the multiplier for greater precision if needed).
                value: Math.round(name === 'CLS' ? delta * 1000 : delta),
                // The `id` value will be unique to the current page load. When sending
                // multiple values from the same page (e.g. for CLS), Google Analytics can
                // compute a total by grouping on this ID (note: requires `eventLabel` to
                // be a dimension in your report).
                event_label: id,
                // Use a non-interaction event to avoid affecting bounce rate.
                non_interaction: true,
            });
        });
        // Custom events
        EventTracking.listen(EventType.Track, ({ category, action, label, value = '' }) => {
            this.sendEvent(category, action, label, value);
        });
    }
    sendEvent(category, action, label, value = '') {
        gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'value': value
        });
    }
}
